export default __webpack_public_path__ + "static/media/aviso-red.6779ab4a.svg";